import script from "./PatientInfoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientInfoPopup.vue?vue&type=script&setup=true&lang=ts"

import "./PatientInfoPopup.vue?vue&type=style&index=0&id=81a1a178&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81a1a178"]])

export default __exports__